/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@repo/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"21iVr3":["Why Intern at Khan Academy"],"+XnQ8+":["Khan Academy is proudly not-for-profit. That means that you'll spend your internship working with a mission-driven team of engineers dedicated to our core goal of providing a free, world-class education for anyone, anywhere. The work you do, even as an intern, will affect millions of learners worldwide."],"1S0Zwe":["During your internship, you'll be assigned to one of our engineering teams based on your interests and paired with a full-time engineer on the same team, who will serve as your mentor throughout the summer. You'll work with your mentor to set goals, solve problems, and develop your intern project."],"rCVlRG":["Your intern project isn't just a demo or busywork, and it certainly won't involve getting anyone coffee. You'll spend the bulk of your summer working on a task that integrates with your team’s broader work and has a real impact on Khan learners around the world. Along the way, you'll develop your coding skills, learn more about what it's like to work as a software engineer, and build professional experience that you'll carry with you into your future career."],"3oRy2s":["Quotes from Past Interns"],"Ba+jpo":["About the Program"],"HJI5Cv":["Work at a mission-driven non-profit"],"iOJrTv":["10-12 week summer internship"],"qEHe/y":["Remote within the United States or Canada"],"uFZiaB":["Competitive pay rate"],"dLzKhZ":["Placement on one of our engineering teams based on your interests"],"UQ4Zkr":["Work with a full-time mentor to develop your skills"],"A1yXOo":["Weeklong intern hackathon"],"v5h8GB":["Fun remote social events and activities"],"/9CMO7":["About the Application"],"M7R2P0":["Applicants should be rising undergraduate juniors and seniors pursuing computer science, engineering, math, or a related field"],"EybG9s":["Applications are typically accepted in October"],"bPgxvd":["Internships at Khan Academy"],"QXL6Yh":["Khan Academy Internships"],"ePLa0y":["View open positions"],"L4Yr/3":["Email me when the application goes live"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["vi","ur","uk","or","km","zh-hant","sk","sgn-us","rw","my","mr","lol","ky","is","it","fv","en-x-rtl","zu","xh","th","te","sw","fa","ms","he","fa-af","ar","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","zh-hans","tr","sr","ro","pt","pl","pa","nb","ko","ka","hy","hi","fr","de","bn","bg","uz","ta","sv","ru","pt-pt","nl","mn","lv","lt","kn","kk","ja","id","hu","gu","en-pt","el","da","cs","boxes","as","az","accents"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
